import { render } from "./Responsive.vue?vue&type=template&id=ae32cdee"
import script from "./Responsive.vue?vue&type=script&lang=ts"
export * from "./Responsive.vue?vue&type=script&lang=ts"
script.render = render

export default script